<!--
@负责人: 黎柏祺
@创建时间: 2018-12-05
@版本:v1.0.26
@描述: 日志分析页-日志查询
-->
<template>
  <div class="logSearch__content">
    <div class="logSearch__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('logAnalysis.time')">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
          {{$t('common.to')}}
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('logAnalysis.group')">
          <g-select :list="select_group" v-model="form.groupName"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logAnalysis.app')">
          <g-select :list="select_app" v-model="form.appName"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logAnalysis.IP')">
          <el-input v-model="form.host"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_searchLog" v-g-rac="gRac('logAnalysisLogSearch_search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_downloadCurPage" v-g-rac="gRac('logAnalysisLogSearch_downloadPage')">{{ $t('logAnalysis.downloadCurrentPage') }}</el-button>
          <el-button type="primary" @click="e_sync" v-g-rac="gRac('logAnalysisLogSearch_sync')">{{ $t('logAnalysis.syncS3') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="logSearch__table">
      <el-table-extend
      :data="tData" 
      :head="tHead"
      :currentChange="tCurrentChange"
      :sizeChange="tSizeChange"
      border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div> 
    <div class="logSearch__downloadList" v-show="table_download.length">
      <div class="ilb mr-base" v-text="$t('logAnalysis.downloadList')"></div>
      <el-button type="primary" @click="e_clearTable" v-text="$t('logAnalysis.clearTableList')"></el-button>
      <div class="mt-base">
        <dynamic-table ref="dynamicTable" :input-data="tableData" :model="tableModel" :custom-fun="deleteTdata" :is-add="isAdd">
        </dynamic-table>
      </div>
      <div class="mt-base">
        <el-form ref="downloadForm" :model="downloadForm" :inline="true" input-width="auto" :rules="downloadFormRule">
          <el-form-item :label="$t('logAnalysis.indexName')" prop="indexName">
            <el-input v-model="downloadForm.indexName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('logAnalysis.taskName')" prop="taskName">
            <el-input v-model="downloadForm.taskName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="e_offlineExport" >{{ $t('logAnalysis.offlineExport') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
    import LogAnalysisBiz from '@/logic/logRetrieve/logRetrieveBiz.js'
    import validateConfig from '@/utils/validate'
    import table from '@/components/mixins/table'
    import dic from '@/components/mixins/dic'
    import rac from '@/plugins/rac-mixin.js'
    import dynamicTable from '@/components/dynamicTable'
    import { extend } from '@/utils/tool'
    import TimeFormat from '@/utils/timeFormat'
    const A_WEEK = 86400000 * 7
    
    export default {
      mixins: [dic, rac, table],
      components: {
        dynamicTable
      },
      data () {
        const that = this
        return {
          initFlag: true,
          form: {
            startTime: '',
            endTime: '',
            groupName: '',
            appName: '',
            host: ''
          },
          tableControl: [{
            label: that.$t('common.download'),
            callback: that.e_download,
            rac: () => that.gRac('logAnalysisLogSearch_download')
          },
          {
            label: that.$t('logAnalysis.downloadLocale'),
            callback: that.e_downloadLocale,
            rac: () => that.gRac('logAnalysisLogSearch_downloadLocal')
          }],
          isAdd: false,
          tableModel: {},
          tableData: [],
          downloadForm: {
            indexName: '',
            taskName: ''
          },
          downloadFormRule: {
            indexName: [{ ...validateConfig.common.notEmpty }],
            taskName: [{ ...validateConfig.common.notEmpty }]
          },
          logSelect: {},
          select_app: {},
          table_download: [],
          task_detail: [],
          select_group: {}
        }
      },
      computed: {
      },
      methods: {
        init () {
          this.waitGroupList()
          this.initTable()
          this.setDynamicData()
          this.form.startTime = new Date().getTime() - 86400000
          this.form.endTime = new Date().getTime()
        },
        async waitGroupList () {
          await this.dGetGroup()
          this.select_group = this.$store.state.dicModule.group
          this.form.groupName = Object.keys(this.select_group)[0]
        },
        async waitAppList (group) {
          await this.dGetAppByGroup('', group)
          this.select_app = { ...this.dDictionaryApp[group] }
          this.form.appName = Object.keys(this.select_app)[0]
          if (this.initFlag) {
            this.initFlag = false
            this.searchLog()
          }
        },
        initTable () {
          this.tInitTable({
            lanKey: 'logAnalysis.table',
            head: ['logTime', 'groupName', 'appName', 'host', 'key', 'logSize'],
            requestFun: this.searchLog,
            headOpt: {}
          })
        },
        setDynamicData () {
          this.tableData = [
            {
              label: this.$t('logAnalysis.table.logTime'),
              type: 'text',
              key: 'logTime'
            },
            {
              label: this.$t('logAnalysis.table.groupName'),
              key: 'groupName',
              type: 'text'
            },
            {
              label: this.$t('logAnalysis.table.appName'),
              key: 'appName',
              type: 'text'
            },
            {
              label: this.$t('logAnalysis.table.key'),
              key: 'key',
              type: 'text'
            },
            {
              label: this.$t('logAnalysis.table.logSize'),
              key: 'logSize',
              type: 'text'
            }
          ]
        },
        e_download (rowData) {
          this.logSelect = { ...rowData }
          if (this.table_download.length < 50) {
            const addObj = {
              logTime: rowData.logTime,
              groupName: rowData.groupName,
              appName: rowData.appName,
              key: rowData.key,
              logSize: rowData.logSize
            }
            if (this.table_download.some(item => item.key === rowData.key)) {
              this.$message({
                message: this.$t('logAnalysis.downloadRepeatAlert'),
                type: 'warning'
              })
              return
            }
            this.table_download.push(addObj)
            this.$nextTick(() => {
              this.$refs.dynamicTable.setData(this.table_download)
              this.setName()
            })
          } else {
            this.$message({
              message: this.$t('logAnalysis.downloadNumAlert'),
              type: 'warning'
            })
          }
        },
        e_downloadLocale (rowData) {
          LogAnalysisBiz.getS3Uri({ id: rowData.id }).then((data) => {
            if (data) {
              window.open(data)
            }
          })
        },
        deleteTdata (item, i) {
          this.table_download.splice(i, 1)
          this.$refs.dynamicTable.setData(this.table_download)
        },
        setName () {
          if (this.table_download.length === 1) {
            const pad2 = (n) => { return n < 10 ? '0' + n : n }
            const date = new Date()
            const time = date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes()) + pad2(date.getSeconds())
            this.downloadForm = {
              indexName: this.table_download[0].appName.toLowerCase() + '-' + time,
              taskName: this.table_download[0].appName.toLowerCase() + '-' + time
            }
          }
        },
        validateForTips ({startTime, endTime, appName, indexName}) {
          let res = false
          if (startTime >= endTime) {
            res = this.$t('logAnalysis.timeAlert')
          } else if (endTime > startTime + A_WEEK) {
            res = this.$t('logAnalysis.timeIntervalAlert')
          } else if (!appName || typeof appName !== 'string') {
            res = this.$t('logAnalysis.appNameAlert')
          } else if (indexName && !(/^[a-z0-9d-]*$/.test(indexName))) {
            res = this.$t('logAnalysis.indexNameAlert')
          }
          return res
        },
        e_searchLog () {
          this.tResetPage()
          this.searchLog()
        },
        searchLog () {
          const res = this.validateForTips({
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            appName: this.form.appName
          })
          if (res) {
            this.$message({
              message: res,
              type: 'warning'
            })
          } else {
            const reqData = extend(true, { ...this.tPageInfo }, this.form)
            LogAnalysisBiz.getS3logList(reqData).then((d) => {
              if (d && d.dataList) {
                d.dataList.map((item) => {
                  item.logTime = TimeFormat.getFormatTime(item.logTime)
                })
              }
              this.tData = d
            })
          }
        },
        e_downloadCurPage () {
          if (this.tData.dataList.length + this.table_download.length <= 50) {
            for (let i = 0; i < this.tData.dataList.length; i++) {
              if (this.table_download.every((item) => {
                return item.key !== this.tData.dataList[i].key
              })) {
                this.table_download.push({
                  logTime: this.tData.dataList[i].logTime,
                  groupName: this.tData.dataList[i].groupName,
                  appName: this.tData.dataList[i].appName,
                  key: this.tData.dataList[i].key,
                  logSize: this.tData.dataList[i].logSize
                })
              }
            }
            this.$refs.dynamicTable.setData(this.table_download)
          } else {
            this.$message({
              message: this.$t('logAnalysis.downloadNumAlert'),
              type: 'warning'
            })
          }
        },
        e_sync () {
          const res = this.validateForTips({
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            appName: this.form.appName
          })
          if (res) {
            this.$message({
              message: res,
              type: 'warning'
            })
          } else {
            LogAnalysisBiz.syncLog(this.form).then((d) => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
            })
          }
        },
        e_offlineExport () {
          const saveInfo = {
            ...this.downloadForm,
            logList: this.table_download
          }
    
          // v2.0.3补丁 离线导入ES 不验证应用名称
          // const validateRes = this.validateForTips({
          //   indexName: saveInfo.indexName
          // })
    
          // if (validateRes) {
          //   this.$message({
          //     message: validateRes,
          //     type: 'warning'
          //   })
          //   return
          // }
          for (let i = 0; i < saveInfo.logList.length; i++) {
            delete saveInfo.logList[i].logTime
          }
          this.$refs.downloadForm.validate((valid) => {
            if (valid) {
              LogAnalysisBiz.saveOfflineTask(saveInfo).then((data) => {
                this.form.startTime = new Date().getTime() - 86400000
                this.form.endTime = new Date().getTime() + 5000
                setTimeout(() => {
                  this.table_download = []
                  this.$message({
                    message: this.$t('common.success'),
                    type: 'success'
                  })
                }, 600)
              })
            }
          })
        },
        e_clearTable () {
          this.table_download = []
          this.$nextTick(() => {
            this.$refs.dynamicTable.setData(this.table_download)
          })
        }
      },
      mounted () {
        this.init()
      },
      watch: {
        'form.groupName' () {
          this.waitAppList(this.form.groupName)
        },
        table_download () {
          let downloadSize = 0
          for (let i = 0; i < this.table_download.length; i++) {
            downloadSize += this.table_download[i].logSize
            if (downloadSize >= 1024) {
              this.table_download.splice(i, 1)
              this.$message({
                message: this.$t('logAnalysis.downloadSizeAlert'),
                type: 'warning'
              })
            }
          }
        }
      }
    }
</script>
<style scoped>
  .logSearch__downloadList {
    font-size: 14px;
    margin-top: 30px;
  }
</style>
       